import api from '@api'
import { eventBus } from '@eventBus'
export default {
    data() {
        return {
            candidate: null
        }
    },
    methods: {
        receiveUUid(uuid) {
            if(!this.candidate) return
            const payload = {
                candidate_id: this.candidate.candidate_info.id,
                call_id: uuid
            }
            if(!this.candidate || !uuid)  return

            api.candidats.assetCall(payload, '', 'post').then().finally(e=>{
                this.candidate = null
            })
        },  

        getRoute(contact) {
            const payload = {
                customer: contact.number    
            }
            return api.chat.telephonySearch(payload,'','post').then(res=>{
                const {type} = res.response
                if(!type) {
                    this.$toast.error(res.response.message)
                    return
                }
                eventBus.$emit('incomingCall', {...res.response, ...{external_call_id:contact.settings.external_call_id}});
                

                if(type == 'driver') { 
                    return this.getRouteOnDriver(res.response)
                } else { 
                    this.candidateAssetCall({contact, candidate_info: res.response.candidate_info})
                    return this.getRouteOnCandidate(res.response)
                }
            }).catch(error=>{
                if(error.message) this.$toast.error(error.message)
                console.error(error)
            }).finally(e=>{
                this.isloading = false
            })
            
        },
        candidateAssetCall(data) {
            const {contact, candidate_info} = data
            if(candidate_info && candidate_info.is_create) {
                eventBus.$emit('candidateAssetCall', {contact, candidate_info})
            }  
        },
        
        getRouteOnDriver(driver) {
            const {park_id,id} = driver.driver_info
            return {name: "DriverDetail", query: { driver_id:id, park_id}}
        },
        getRouteOnCandidate(candidate) {
            const {id} = candidate.candidate_info
            this.candidate = candidate
            return {name: 'CandidateEdit', query: {id}}    
        },
        handleAcceptIncCall(item) {
            if (this.$route.name === 'OperatorWorkspace') {
                item.settings.workspaceContext = item.settings.workspaceContext || { pending: true }
                eventBus.$emit('operator-workspace-call', item)
                return
            }
            const company = item.company.settings || {}
            const contact = item
            if (this.$route.name == 'DriverDetail') this.$router.replace({ name: 'dashboard' }); //убирать нельзя, надо для корректного перехода на страницу водитьеля с странице другого водителя
            if (company.can_change_company) {
                this.changeCompany(company).then(res => {
                    this.refresh = false
                    this.$nextTick(() => {
                        this.refresh = true
                        if(contact) {
                            this.getRoute(contact).then(routeOnDriver=>{
                                this.$nextTick(() => {
                                    if(this.IsSame(routeOnDriver)) return
                                    this.$router.push(routeOnDriver)
                                })
                            })
                        }
                    })
                    eventBus.$emit('companyIsChanget');
                })
            }
            else {
                this.getRoute(contact).then(routeOnDriver=>{
                    if(!routeOnDriver) return
                    if(this.IsSame(routeOnDriver)) return
                    this.$router.push(routeOnDriver)
                })
            }
        },
        IsSame(routeOnDriver) {
            const ret = this.$router.resolve(routeOnDriver).href == this.$route.fullPath
            console.log('IsSame', {
                ret,
                href: this.$router.resolve(routeOnDriver).href,
                fullPath: this.$route.fullPath,
                routeOnDriver
            })
            return ret
        }
    },
}
